var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"search-float-btn",attrs:{"href":"/Search/Index","title":_vm.$t('Search'),"target":"_blank"}},[_c('i',{staticClass:"material-icons"},[_vm._v("search")])])
}
var staticRenderFns = []

export { render, staticRenderFns }